import { render, staticRenderFns } from "./GeracaoProposta.vue?vue&type=template&id=0971e34c&scoped=true&"
import script from "./GeracaoProposta.vue?vue&type=script&lang=js&"
export * from "./GeracaoProposta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0971e34c",
  null
  
)

export default component.exports